import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';

/**
 * ログインエラー画面
 *
 * @export KYMW1003Component
 * @class KYMW1003Component
 * @implements {OnInit}
 */
@Component({
  selector: 'app-kymw1003',
  templateUrl: './kymw1003.component.html',
  styleUrls: ['./kymw1003.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class KYMW1003Component extends PlessViewHelperSub implements OnInit {

  /**
   *Creates an instance of KYMW1000Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1003Component
   */

  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model) {
    super(kymw00Model);
  }

  public ngOnInit(): void {
    this.componentName = 'KYMW1003';
  }
}
